import { createAsyncThunk } from "@reduxjs/toolkit";
// import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";

export const fetchTemplate = createAsyncThunk(
  "template/fetchTemplate",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    // console.log("sort : ", sort);



    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (!filterField || filterValue === undefined || filterValue === null) return;

          // If filterValue is an object (like from_date/to_date)
          if (typeof filterValue === "object" && filterValue !== null) {
            if (filterValue.from_date)
              params.append(`${filterField}_date_from`, filterValue.from_date);
            if (filterValue.to_date)
              params.append(`${filterField}_date_to`, filterValue.to_date);
          } else {
            // Primitive value
            params.append(filterField, String(filterValue));
          }
        }
      );
    }

    // console.log(`api/item/?${params.toString()}`)
    const response: any = await Axios.get(`api/templates/list/?${params.toString()}`);
    // console.log("itemResponse : ", filters);
    // const response: any = await Axios.get(`/item/`, {
    //   params: {
    //     page,
    //     page_size: pageSize,
    //     search: search || undefined,
    //     filters: filters ? JSON.stringify(filters) : undefined,
    //   },
    // });

    // console.log("thunk", response)
    return {
      data: response?.data?.data || [],
      rowCount:
        (response?.data && (response?.data?.count ?? response?.data?.total)) ||
        0,
    };
  }
);

export const fetchTemplateById = createAsyncThunk(
  "template/fetchTemplateById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/api/templates/view-details/${id}/`);
      // console.log(response)
      return response?.data?.data ?? response?.data ?? response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Template by ID");
    }
  }
);

export const fetchItemByDropDown = createAsyncThunk(
  "template/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/Item/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Item list");
    }
  }
);

export const updateTemplate = createAsyncThunk(
  "template/updateTemplate",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `/api/templates/edit/${payload?.template_id}/`,
        payload
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GP");
    }
  }
);

export const updateTemplateStatus = createAsyncThunk(
  "template/updateTemplateStatus",
  async (id: any, { rejectWithValue }) => {
    try {
      // const payload = { is_active: itemData.is_active };
      const response: any = await Axios.patch(
        `/api/templates/edit-status/${id}/`,
      );

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update Template Status");
    }
  }
);

export const addTemplate = createAsyncThunk(
  "template/addTemplate",
  async (payload: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`/api/templates/create/`, payload);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add Template");
    }
  }
);

//Exports csv file
export const exportTemplateCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (!filterField || filterValue === undefined || filterValue === null) return;

        // If filterValue is an object (like from_date/to_date)
        if (typeof filterValue === "object" && filterValue !== null) {
          if (filterValue.from_date)
            params.append(`${filterField}_date_from`, filterValue.from_date);
          if (filterValue.to_date)
            params.append(`${filterField}_date_to`, filterValue.to_date);
        } else {
          // Primitive value
          params.append(filterField, String(filterValue));
        }
      }
    );
  }
  // Step 1: First call – get the file_url
  const response = await Axios.get(`/api/templates/export-to-excel/?${params.toString()}`);

  const fileUrl = response.data?.file_url;
  if (!fileUrl) {
    throw new Error("No file_url found in API response");
  }

  // Step 2: Second call – download the file as blob
  const downloadResponse = await Axios.get(fileUrl, {
    responseType: "blob",
  });

  // Step 3: Get filename from file_url
  const filename = fileUrl.split("/").pop() || "template.xlsx";

  return {
    blob: downloadResponse.data,
    filename,
  };
};


export const deleteTemplateById = createAsyncThunk(
  "template/deleteTemplateById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.delete(`/api/templates/delete/${id}/`);
      if (response?.data?.success) {
        return { id }; // return the deleted item's id
      }
      return rejectWithValue("Failed to delete Template");
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to delete Template");
    }
  }
);



// Change the selected Template with latest items
export const updateTemplateWithLatestItems = createAsyncThunk(
  "template/updateTemplateWithLatestItems",
  async (payload: any, { rejectWithValue }) => {
    try {
      return payload;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update Template with latest items");
    }
  }
);